import { useCallback } from "react";
import {
  useListValidationsApiV1ModelsCatalogValidationsGet,
  useDeleteValidationApiV1ModelsCatalogValidationsValidationIdDelete,
  ListValidationsApiV1ModelsCatalogValidationsGetQueryParams,
} from "vl-api/vlComponents";

export const useValidationJobsTable = (
  apiQueryParams: ListValidationsApiV1ModelsCatalogValidationsGetQueryParams,
) => {
  const {
    data,
    isLoading: loading,
    refetch: fetchListData,
  } = useListValidationsApiV1ModelsCatalogValidationsGet(
    { queryParams: apiQueryParams },
    {
      enabled: true,
    },
  );

  const deleteMutation =
    useDeleteValidationApiV1ModelsCatalogValidationsValidationIdDelete();
  const isDeleting = deleteMutation.isPending;

  const tableData = data?.validations || [];

  const handleDelete = useCallback(
    async (validationId: string) => {
      try {
        await deleteMutation.mutateAsync({
          pathParams: { validationId },
        });
        fetchListData();
      } catch (err: any) {
        throw (
          err?.response?.detail ||
          err?.error ||
          "Failed to delete validation job."
        );
      }
    },
    [fetchListData, deleteMutation],
  );

  return {
    tableData,
    loading,
    fetchListData,
    handleDelete,
    isDeleting,
    totalItemsCount: data?.total,
  };
};
